// src/modules/Investors/components/InvestorLayout.js
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { supabase } from '../../../config/supabase';
import { FaSignOutAlt } from 'react-icons/fa';
import logoVega from '../../../assets/logovega.svg';

const LayoutContainer = styled.div`
  min-height: 100vh;
  background: #fafafa;
`;

const Header = styled.header`
  background: white;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 100;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    height: 28px;
  }
`;

const Badge = styled.span`
  padding: 4px 10px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const UserInfo = styled.div`
  text-align: right;

  .name {
    font-size: 14px;
    font-weight: 600;
    color: #111;
  }

  .company {
    font-size: 12px;
    color: #666;
  }
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  transition: all 200ms;

  &:hover {
    background: #f5f5f5;
    color: #111;
    border-color: #ddd;
  }
`;

const MainContent = styled.main`
  padding: 32px 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Footer = styled.footer`
  padding: 24px;
  text-align: center;
  color: #999;
  font-size: 12px;
  border-top: 1px solid #f0f0f0;
  margin-top: 48px;
  background: white;

  a {
    color: #666;
    text-decoration: none;

    &:hover {
      color: #111;
    }
  }
`;

const InvestorLayout = ({ investorData }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (investorData?.email) {
      await supabase
        .from('investor_access_logs')
        .insert({
          investor_email: investorData.email,
          action: 'logout'
        });
    }

    await supabase.auth.signOut();
    navigate('/investidores/login');
  };

  return (
    <LayoutContainer>
      <Header>
        <LogoSection>
          <img src={logoVega} alt="Vega Robotics" />
          <Badge>Investidor</Badge>
        </LogoSection>

        <UserSection>
          <UserInfo>
            <div className="name">{investorData?.name || 'Investidor'}</div>
            {investorData?.company && (
              <div className="company">{investorData.company}</div>
            )}
          </UserInfo>
          <LogoutButton onClick={handleLogout}>
            <FaSignOutAlt />
            Sair
          </LogoutButton>
        </UserSection>
      </Header>

      <MainContent>
        <Outlet context={{ investorData }} />
      </MainContent>

      <Footer>
        <p>
          Vega Robotics &copy; {new Date().getFullYear()} &bull;{' '}
          <a href="https://www.vegarobotics.com.br" target="_blank" rel="noopener noreferrer">
            vegarobotics.com.br
          </a>
        </p>
      </Footer>
    </LayoutContainer>
  );
};

export default InvestorLayout;
